var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstrumentalTwoThree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E5EAFF;}\r\n\t.st1{fill:#646464;}\r\n\t.st2{fill:#BFCCFF;}\r\n\t.st3{fill:#80FFFF;}\r\n\t.st4{fill:#7DF894;}\r\n\t.st5{fill:#FDFF20;}\r\n\t.st6{fill:#FFC800;}\r\n\t.st7{fill:#FFFFFF;}\r\n\t.st8{fill:#FF9100;}\r\n\t.st9{fill:#F03903;}\r\n\t.st10{fill:#C50700;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2849_",
    className: "st2",
    d: "M256.1,1.7c140.3,0,254,113.7,254,254c0,140.2-113.7,253.9-254,253.9 c-140.3,0-254-113.7-254-253.9C2.1,115.5,115.8,1.7,256.1,1.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58.6,171.2h33.1v168.9H58.6V171.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M127.4,171.2h33.1v168.9h-33.1V171.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M191.3,256.9h60.6v27.7h-60.6V256.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M283,171.2h33.1v168.9H283V171.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M351.8,171.2h33.1v168.9h-33.1V171.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M420.5,171.2h33.1v168.9h-33.1V171.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstrumentalTwoThree);
export default __webpack_public_path__ + "static/media/InstrumentalTwoThree.3cb0a6254102c768303615a00bd5fea8.svg";
export { ForwardRef as ReactComponent };